// extracted by mini-css-extract-plugin
export default {"ProjectNav__tab":"ProjectNav_ProjectNav__tab__fT2Hk"};